export const stringOrUndefined = (value?: string | null): string | undefined => {
  if (value && value !== '') {
    return value
  }
  return undefined
}
